import requests from "./httpService";

const UserServices = {

    // User self
    getMyProfile: async () => {
        return requests.get(`/users/me`);
    },
    updateMyProfile: async (body) => {
        return requests.put(`/users/me`, body);
    },
    changeMyPassword: async (body) => {
        return requests.put(`/users/me/password`, body);
    },

    // Admin: user list & management
    getAllUser: async (params = {}) => {
        const query = new URLSearchParams(params).toString();
        return requests.get(`/users${query ? `?${query}` : ''}`);
    },
    updateUserStatus: async (id, body) => {
        return requests.put(`/users/${id}/status`, body);
    },
    getDashboard: async () => {
        return requests.get(`/users/dashboard`);
    },

    // Auth
    userLogin: async (body) => {
        return requests.post(`/auth/login`, body);
    },
    verifyLoginOtp: async (body) => {
        return requests.post(`/auth/login/verify`, body);
    },
    verifyOtp: async (body) => {
        return requests.post(`/auth/verifyotp`, body);
    },
    userRegister: async (body) => {
        return requests.post(`/auth/register`, body);
    },
    verifyRegisterOtp: async (body) => {
        return requests.post(`/auth/register/verify`, body);
    },
    refreshToken: async (body) => {
        return requests.post(`/auth/refresh`, body);
    },

    // Contact (kept for backward compat)
    updateContactDetail: async (body) => {
        return requests.put(`/content/contact`, body);
    },
}

export default UserServices;
